"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wizard = exports.WizardWrapper = exports.WizardProgress = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WizardProgress = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-wizard-progress"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  padding: 30px 0 0;\n  width: 300px;\n  overflow: visible;\n  margin-top: 90px;\n\n  & ul {\n    position: relative;\n    z-index: 3;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &:before {\n    display: block;\n    position: absolute;\n    content: \"\";\n    width: 60px;\n    height: 100%;\n    top: 0;\n    left: 0;\n    border-radius: 30px;\n    background: #fff;\n    z-index: 1;\n    ", ";\n  }\n"])), function (props) {
  return props.theme.Elevate.fader;
});
exports.WizardProgress = WizardProgress;

var Dotted = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n  transition: ", ";\n"])), function (props) {
  return props.theme.PrimaryTransition;
});

var WizardLi = (0, _styledComponents["default"])("li").attrs({
  className: "flexi-wizard-list"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    min-height: ", ";\n    display: grid;\n    grid-template-columns: 60px auto;\n    cursor: pointer;\n    & .flexi-wizard-progress-li{\n        display: flex;\n        justify-content: center;\n    }\n    & span{\n        display: ", ";\n        padding: 5px 20px;\n        font-size: 0.8rem;\n        transition: 0.2s ease-in;\n        line-height: 1.2rem;\n        ", "\n        ", "\n        ", "\n    }\n    ", "{\n    display: block;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    border: none;\n    background: none;\n    \n\n    &:after{\n        content: '';\n        display: block;\n        border-radius: 50%;\n        background: ", ";\n        width: 12px;\n        height: 12px;\n        position: relative;\n        z-index: 3;\n    }\n    &:before{\n        content: '';\n        display: block;\n        width: 0;\n        height: ", ";\n        position: absolute;\n        left: calc(50% - 0.5px);\n        border-left: 1px dashed ", ";\n        top: 5px;\n        z-index: -1;\n    }\n    ", "\n    ", "\n    ", "\n    }\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.displayLabels ? "block" : "none";
}, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
}, function (props) {
  return props.focus && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            font-size: 0.9rem;\n            font-weight: bold;\n          "])));
}, function (props) {
  return props.last && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
}, Dotted, function (props) {
  return props.inactiveColor ? props.inactiveColor : props.theme.PrimaryBorderColor;
}, function (props) {
  return props.height;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryBorderColor;
}, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        &:after {\n          background: ", ";\n        }\n        &:before {\n          border-left: 1px solid\n            ", ";\n        }\n      "])), function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  });
}, function (props) {
  return props.focus && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        border: 1px solid\n          ", ";\n        background: #fff;\n        &:after {\n          background: ", ";\n        }\n        &:before {\n          border-left: 1px dashed\n            ", ";\n        }\n      "])), function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  });
}, function (props) {
  return props.last && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        &:before {\n          display: none;\n        }\n      "])));
});
WizardLi.defaultProps = {
  height: "70px",
  active: false,
  focus: false,
  last: false
};
WizardLi.propTypes = {
  height: _propTypes["default"].string,
  color: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  last: _propTypes["default"].bool,
  displayLabels: _propTypes["default"].bool
};
var WizardWindow = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-wizard-window"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: none;\n  ", "\n  margin: 0 auto;\n  max-width: ", ";\n"])), function (props) {
  return props.inView && (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      display: block;\n    "])));
}, function (props) {
  return props.width;
});
var WizardTitle = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-wizard-title"
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 30px;\n    left: 30px;\n    display: inline-flex;\n    border-radius: 30px;\n    height: 60px;\n    background: #fff;\n    ", ";\n    padding: 0 30px 0 80px;\n    margin-bottom: 20px;\n    align-items: center;\n    &:after{\n        width: 60px;\n        height: 60px;\n        border-radius: 30px;\n        display: block;\n        content: '';\n        border: 1px solid ", ";\n        position: absolute;\n        top: -1px;\n        left: -1px;\n        background: #fff;\n        z-index:1;\n    }\n    &:before{\n        width: 24px;\n        height: 24px;\n        border-radius: 12px;\n        display: block;\n        content: '';\n        box-sizing: border-box;\n        border: 1px solid ", "; \n        padding: 3px;\n        background-clip: content-box; /* support: IE9+ */\n        position: absolute;\n        top: 18px;\n        left: 18px;\n        background-color: ", ";\n        z-index: 2;\n    }\n    h1{\n        color: ", ";\n        margin: 0;\n        padding: 0;\n        line-height: 1rem;\n        font-size: 1rem;\n    }\n"])), function (props) {
  return props.theme.Elevate.fader;
}, function (props) {
  return props.theme.PrimaryBorderColor;
}, function (props) {
  return props.theme.PrimaryBorderColor;
}, function (props) {
  return props.theme.PrimaryBorderColor;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
});
var WizardFoot = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-wizard-foot"
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  padding: 30px;\n  border-top: 1px solid ", ";\n  background: rgba(0, 0, 0, 0.02);\n"])), function (props) {
  return props.theme.PrimaryBorderColor;
});
var WizardWrapper = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-wizard"
})(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 20 auto;\n  padding-bottom: 90px;\n  background: ", ";\n  border-radius: ", ";\n  ", ";\n  position: relative;\n  overflow: hidden;\n  & .flexi-wizard-wrapper {\n    padding: 30px;\n    display: grid;\n    grid-gap: 30px;\n    grid-template-columns: minmax(300px, max-content) auto;\n    ", "\n  }\n\n  @media (max-width: 800px) {\n    & .flexi-wizard-wrapper {\n      grid-template-columns: 60px auto;\n    }\n    & .flexi-wizard-left {\n      ", " {\n        width: 60px;\n        ", " {\n          & span {\n            display: none;\n          }\n        }\n      }\n    }\n    & .flexi-wizard-right {\n      margin-top: 90px;\n    }\n    ", " {\n      background: none;\n      border: none;\n      box-shadow: none;\n      padding-left: 60px;\n      & h1 {\n        font-size: 0.8rem;\n      }\n      &:after {\n        display: none;\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.PrimaryFade;
}, function (props) {
  return props.theme.SecondaryRadius;
}, function (props) {
  return props.theme.Elevate.high;
}, function (props) {
  return !props.displayLabels && (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n        grid-template-columns: 60px auto;\n      "])));
}, WizardProgress, WizardLi, WizardTitle);
exports.WizardWrapper = WizardWrapper;

var Wizard = function Wizard(props) {
  var _useState = (0, _react.useState)(props.view),
      _useState2 = _slicedToArray(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var incrementStep = function incrementStep() {
    var steps = props.children.length;

    if (view < steps - 1) {
      setView(view + 1);
    }
  };

  var decrementStep = function decrementStep() {
    if (view > 0) {
      setView(view - 1);
    }
  };

  (0, _react.useEffect)(function () {
    setView(props.view);
  }, [props.view]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react["default"].createElement(WizardWrapper, props, /*#__PURE__*/_react["default"].createElement(WizardTitle, null, /*#__PURE__*/_react["default"].createElement("h1", null, props.title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flexi-wizard-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flexi-wizard-left"
    }, /*#__PURE__*/_react["default"].createElement(WizardProgress, null, /*#__PURE__*/_react["default"].createElement("ul", null, props.children && (props.children.length > 1 ? props.children.map(function (elem, index) {
      return /*#__PURE__*/_react["default"].createElement(WizardLi, {
        displayLabels: props.displayLabels,
        onClick: function onClick() {
          return setView(index);
        },
        focus: index === view,
        active: !elem.props.skip && (index < view || elem.props.active),
        last: index === props.children.length - 1,
        key: "wizard-list-".concat(index, "-").concat(elem.props.title)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flexi-wizard-progress-li"
      }, /*#__PURE__*/_react["default"].createElement(Dotted, null)), /*#__PURE__*/_react["default"].createElement("span", null, elem.props.title));
    }) : /*#__PURE__*/_react["default"].createElement(WizardLi, {
      focus: true,
      active: true,
      last: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flexi-wizard-progress-li"
    }, /*#__PURE__*/_react["default"].createElement(Dotted, null)), /*#__PURE__*/_react["default"].createElement("span", null, props.children.props.title)))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flexi-wizard-right"
    }, props.children && (props.children.length > 1 ? props.children.map(function (elem, index) {
      return /*#__PURE__*/_react["default"].createElement(WizardWindow, {
        width: elem.props.width ? elem.props.width : props.width,
        inView: index === view,
        key: "wizard-body-".concat(index, "-").concat(elem.props.title)
      }, /*#__PURE__*/_react["default"].createElement(_.Box, null, /*#__PURE__*/_react["default"].createElement(_.Box, null, elem.props.children), (props.autoProceed || elem.autoProceed) && /*#__PURE__*/_react["default"].createElement(_.Box, {
        pad: "30px 0",
        align: props.buttonAlign
      }, /*#__PURE__*/_react["default"].createElement(_.Button, {
        pale: true,
        color: "rgba(0,0,0,0)",
        fontColor: "#777",
        iconLeft: /*#__PURE__*/_react["default"].createElement("i", {
          className: theme.Icons.previous
        }),
        spaceRight: true,
        onClick: function onClick() {
          return decrementStep();
        },
        height: 48,
        width: 120,
        disabled: elem.props.disable || index === 0
      }, "Previous"), index < props.children.length - 1 ? /*#__PURE__*/_react["default"].createElement(_.Button, {
        iconRight: /*#__PURE__*/_react["default"].createElement("i", {
          className: theme.Icons.next
        }),
        onClick: function onClick() {
          return incrementStep();
        },
        height: 48,
        width: 120
      }, "Next") : props.finish && props.finish)));
    }) : /*#__PURE__*/_react["default"].createElement(WizardWindow, {
      width: props.children.props.width ? props.children.props.width : props.width,
      inView: true
    }, props.children.props.children)))), props.onClose && /*#__PURE__*/_react["default"].createElement(WizardFoot, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
      fontColor: theme.PrimaryColor,
      color: "rgba(255,255,255,0)",
      onClick: props.onClose
    }, "Cancel")));
  });
};

exports.Wizard = Wizard;
Wizard.defaultProps = {
  view: 0,
  autoProceed: true,
  width: "1000px",
  displayLabels: true,
  buttonAlign: "right"
};
Wizard.propTypes = _defineProperty({
  view: _propTypes["default"].number,
  finish: _propTypes["default"].element,
  autoProceed: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  width: _propTypes["default"].string,
  displayLabels: _propTypes["default"].bool,
  buttonAlign: _propTypes["default"].string,
  onClose: _propTypes["default"].any,
  title: _propTypes["default"].string
}, "finish", _propTypes["default"].element);